import React from "react";
import clsx from "clsx";
import { Theme } from "@material-ui/core/styles";
import makeStyles from "@material-ui/core/styles/makeStyles";
import AccessControl from "../../../../components/AccessControl";
import { AdapterLink } from "../../../../components/Adopter";
import { Routes } from "../../../../constants/routes";
import { useContactConfig } from "../../../contact/modals/view/config";
import { EducationType } from "../../../school/constants/types";
import { UserRole } from "../../../user/enums/UserRole";
import { useAuth } from "../../../auth/hooks/useAuth";
import { useWizard } from "../../../wizard/context";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginLeft: 60,
    display: "flex",
  },
  link: {
    marginRight: 30,
    "&:hover, &.active": {
      textDecoration: "none",
      color: theme.palette.secondary.dark,
    },
  },
  contactUs: {
    color: "#231f20",
    cursor: "pointer",
  },
}));

const HeaderMenu = () => {
  const classes = useStyles();
  const { profile } = useAuth();
  const { openWizard } = useWizard();
  const contactConfig = useContactConfig();

  const schoolTypeId = profile?.data?.data?.school?.type?.id;

  const handleOpenContact = async () => {
    await openWizard(contactConfig);
  };

  return (
    <div className={classes.root}>
      <AccessControl allowedRoles={[UserRole.School]}>
        <AdapterLink to={`/0/${Routes.BRANCHES}`} className={classes.link}>
          Branches
        </AdapterLink>
        {schoolTypeId === EducationType.Language ? (
          <AdapterLink
            to={`/0/${Routes.LANGUAGE_COURSES}`}
            className={classes.link}
          >
            Courses
          </AdapterLink>
        ) : (
          <AdapterLink to={`/0/${Routes.ACADEMICS}`} className={classes.link}>
            Academics
          </AdapterLink>
        )}
        <AdapterLink to={`/0/${Routes.STUDENTS}`} className={classes.link}>
          Students
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.BILLING}`} className={classes.link}>
          Billing
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.MESSAGES}`} className={classes.link}>
          Messages
        </AdapterLink>
        <span
          className={clsx(classes.link, classes.contactUs)}
          onClick={handleOpenContact}
        >
          Contact Us
        </span>
        <AdapterLink
          className={classes.link}
          href={
            schoolTypeId === EducationType.Higher
              ? Routes.HIGHER_SCHOOL_GUIDE
              : Routes.SECONDARY_SCHOOL_GUIDE
          }
          target="_blank"
        >
          Help
        </AdapterLink>
      </AccessControl>

      <AccessControl allowedRoles={[UserRole.ServiceProvider]}>
        <AdapterLink to={`/0/${Routes.SERVICE_LIST}/management`} className={classes.link}>
          Services
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.MESSAGES}`} className={classes.link}>
          Messages
        </AdapterLink>
        <span
          className={clsx(classes.link, classes.contactUs)}
          onClick={handleOpenContact}
        >
          Contact Us
        </span>
      </AccessControl>

      <AccessControl allowedRoles={[UserRole.Agent, UserRole.Parent]}>
        <AdapterLink to={`/0/${Routes.PROGRAMS}`} className={classes.link}>
          Programs
        </AdapterLink>
        <AdapterLink
          to={`/0/${Routes.PRIVATE_CLASSES}`}
          className={classes.link}
        >
          Private Classes
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.SERVICE_LIST}`} className={classes.link}>
          Services
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.STUDENTS}`} className={classes.link}>
          Students
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.BILLING}`} className={classes.link}>
          Billing
        </AdapterLink>
        <span
          className={clsx(classes.link, classes.contactUs)}
          onClick={handleOpenContact}
        >
          Contact Us
        </span>
        <AdapterLink
          className={classes.link}
          href={Routes.AGENT_GUIDE}
          target="_blank"
        >
          Help
        </AdapterLink>
      </AccessControl>

      <AccessControl allowedRoles={[UserRole.Student]}>
        <AdapterLink to={`/0/${Routes.PROGRAMS}`} className={classes.link}>
          Programs
        </AdapterLink>
        <AdapterLink
          to={`/0/${Routes.PRIVATE_CLASSES}`}
          className={classes.link}
        >
          Private Classes
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.SERVICE_LIST}`} className={classes.link}>
          Services
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.APPLICATIONS}`} className={classes.link}>
          Applications
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.BILLING}`} className={classes.link}>
          Billing
        </AdapterLink>
        <AdapterLink to={`/0/${Routes.MESSAGES}`} className={classes.link}>
          Messages
        </AdapterLink>
        <span
          className={clsx(classes.link, classes.contactUs)}
          onClick={handleOpenContact}
        >
          Contact Us
        </span>
      </AccessControl>
    </div>
  );
};
export default React.memo(HeaderMenu);
